import React from "react";

function Info() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9971 21.9952C17.5186 21.9952 21.9947 17.5191 21.9947 11.9976C21.9947 6.47607 17.5186 2 11.9971 2C6.47558 2 1.99951 6.47607 1.99951 11.9976C1.99951 17.5191 6.47558 21.9952 11.9971 21.9952Z"
        stroke="#D97706"
        stroke-width="1.59961"
      />
      <path
        d="M11.9971 7.99805V11.998"
        stroke="#D97706"
        stroke-width="1.59961"
        stroke-linecap="round"
      />
      <path
        d="M11.9973 16.7973C12.4391 16.7973 12.7973 16.4391 12.7973 15.9973C12.7973 15.5554 12.4391 15.1973 11.9973 15.1973C11.5554 15.1973 11.1973 15.5554 11.1973 15.9973C11.1973 16.4391 11.5554 16.7973 11.9973 16.7973Z"
        fill="#D97706"
      />
    </svg>
  );
}

export default Info;
